import background from '../../images/background.jpeg';

export default (theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    backgroundSize: 'cover !important',
    background: `url('${background}') no-repeat`,
    backgroundPositionX: '20%',
    [theme.breakpoints.up('md')]: {
      backgroundImage: 'none',
      backgroundColor: 'white',
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: '2.5rem',
    justifyContent: 'center',
  },
  featurePanel: {
    display: 'flex',
    height: '100%',
    position: 'relative',
    backgroundSize: 'cover !important',
    background: `url('${background}') no-repeat`,
    backgroundPositionX: '20%',
  },
  mainPanel: {
    maxHeight: '100%',
    height: '100%',
    paddingTop: '3rem',
    paddingBottom: '3rem',
    flexDirection: 'column',
    display: 'flex',
    justifyContent: 'center',
    overflowY: 'auto',
  },
  row: {
    height: '100%',
    background: 'rgba(255,255,255,0.97)',
  },
  button: {
    backgroundColor: '#e41613 !important',
  },
  buttonLabel: {
    color: 'white',
  },
});
